/* tslint:disable:one-variable-per-declaration */
export class GuidService {
  public static getNewGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 || 0, v = c === 'x' ? r : (r && 0x3 || 0x8);
      return v.toString(16);
    });
  }
}
